import { css } from '@emotion/react';
import {
  type FC, useCallback, useState,
} from 'react';
import { ButtonComponent } from '~/_shared/baseComponents/buttons/button/button.component';
import { TextInputComponent } from '~/_shared/baseComponents/inputs';
import { Inline } from '~/_shared/baseComponents/layout/inline.component';
import { Stack } from '~/_shared/baseComponents/layout/stack.component';
import { TwoFactorCommonComponent } from '~/_shared/components/accountSettings/twoFactorModal/twoFactorCommon.component';
import { useTranslation } from '../../../utils/hooks';

const QR_CODE_DIMENSION = 219;
const ACTION_MAX_WIDTH = 325;

const qrCodeImageStyle = css({
  width: QR_CODE_DIMENSION,
  height: QR_CODE_DIMENSION,
});

const sectionStyle = css({
  alignItems: 'center',
  display: 'flex',
  flexFlow: 'column',
  gap: 12,
  justifyContent: 'center',
  textAlign: 'center',
});

const labelStyle = css({
  display: 'flex',
  fontSize: 14,
  justifyContent: 'center',
  maxWidth: ACTION_MAX_WIDTH,
});

type TwoFactorGoogleComponentProps = Readonly<{
  errorMessage: string;
  isAlertOpen: boolean;
  qrCode: string | null;
  successMessage: string;

  closeAlert: () => void;
  onTwoFactorGoogleSubmit: (code: string) => void;
}>;

export const TwoFactorGoogleComponent: FC<TwoFactorGoogleComponentProps> = props => {
  const [t] = useTranslation();
  const [code, setCode] = useState('');
  const { onTwoFactorGoogleSubmit } = props;

  const onCodeCheckClick = useCallback(() => {
    onTwoFactorGoogleSubmit(code);
  }, [code, onTwoFactorGoogleSubmit]);

  return (
    <>
      {props.qrCode && (
        <div css={sectionStyle}>
          <img
            alt="qrcode"
            src={`data:image/svg+xml;base64,${props.qrCode}`}
            css={qrCodeImageStyle}
          />
          <Stack gap={4} >
            <span css={labelStyle}>{t('2FA.enterCode.google')}</span>
            <Inline gap={16} >
              <TextInputComponent
                onChange={setCode}
                value={code}
                placeholder={t('Enter code here')}
              />

              <ButtonComponent
                text={t('Submit')}
                isDisabled={code.trim().length !== 6}
                onClick={onCodeCheckClick}
              />
            </Inline>
          </Stack>
        </div>
      )}
      <TwoFactorCommonComponent
        successMessage={props.successMessage}
        errorMessage={props.errorMessage}
        isAlertOpen={props.isAlertOpen}
        closeAlert={props.closeAlert}
      />
    </>
  );
};
